import React, { memo, useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Button from '../Button'

import cn from 'classnames'
import styles from './TopNav.module.scss'
import { ReactComponent as YellowSummaryIcon } from '../../assets/icons/yellow-summary-icon.svg'
import { ReactComponent as GreySummaryIcon } from '../../assets/icons/grey-summary-icon.svg'
import { ReactComponent as GreyMobileSummaryIcon } from '../../assets/icons/summary-mobile.svg'
import { ReactComponent as YellowMobileSummaryIcon } from '../../assets/icons/yellow-summary-mobile.svg'
import { ReactComponent as InputSearchIcon } from '../../assets/input-search-icon.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/Close-Icon.svg'
import ConfirmDialog from '../dialog/ConfirmDialog'

const TopNav = ({ currentSearch, hasUnsyncedOrders, onClearSearch, onSearch, safIsUploading,
    setSafIsUploading, isKiosk, className }) => {
  const classNames = cn(styles.TopNav, className)
  const mediaQueryMobile = window?.matchMedia("(max-width: 750px)")
  const history = useHistory()
  const [isSearchOpen, setSearchOpen] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)

  const stopSyncMessage = "Navigation is not supported while a sync is in progress.  Stopping the sync will leave some orders unsynced."
  let confirmNavigationModal
  if (showConfirm) {
    confirmNavigationModal = (
    <ConfirmDialog
      title="Stop Syncing Process?"
      message={stopSyncMessage}
      cancelButtonText="Continue Sync"
      confirmButtonText="Stop Sync"
      onCancel={() => {
        setShowConfirm(false)
      }}
      onConfirm={() => {
        history.push('/concession-order')
        setSafIsUploading(false)
      }}
    />
    )
  }

  useEffect(() => {
    if(!isSearchOpen){
      onClearSearch()
    }
  }, [isSearchOpen])

  const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => {htmlElRef.current &&  htmlElRef.current.focus()}

    return [ htmlElRef, setFocus ]
  }

  const [inputFocus, setInputFocus] = useFocus() // sets focus to <input> using ref if search icon is clicked

  const onSummaryClick = () => {
    history.push('orders/device-summary')
  }

  const onNewOrderClick = () => {
    if (!safIsUploading) {
      history.push('/concession-order')
    } else {
      setShowConfirm(true)
    }
  }

  const onSearchFocus = () =>  {
    setSearchOpen(true)
  }
  const onSearchBlur = () => {
    if(currentSearch !== ''){
      setSearchOpen(true)
    } else {
      setSearchOpen(false)
    }
  }

  const onClearClick = () => {
    onClearSearch()
    setSearchOpen(false)
  }

  return (
    <div className={classNames}>
      {!mediaQueryMobile.matches ?
        <div className={styles.row}>
          <div className={styles.col}>
            <div className={styles.summaryIconContainer} onClick={onSummaryClick}>
              {hasUnsyncedOrders ?
                (<YellowSummaryIcon className={styles.summaryIcon} />) :
                (<GreySummaryIcon className={styles.summaryIcon} />)
              }
            </div>
          </div>

          <div className={styles.col}>
            {!isKiosk && <Button className={styles.newOrderBtn} onClick={onNewOrderClick}>
              New Order
            </Button>}
          </div>
        </div>
    
      : 
        <div className={styles.row}>
          {!isSearchOpen &&
            <div className={styles.leftSummary}>
              {hasUnsyncedOrders ?
                (<YellowMobileSummaryIcon onClick={onSummaryClick} className={styles.mobileSummaryIcon} />) :
                (<GreyMobileSummaryIcon onClick={onSummaryClick} className={styles.mobileSummaryIcon} />)
              }
            </div>
          }
          
          <div className={styles.fieldContainer}>
            <div className={isSearchOpen ? styles.searchIconContainer : styles.searchCloseContainer}>
              <InputSearchIcon className={styles.searchIcon} onClick={setInputFocus} />
            </div>
            <input ref={inputFocus}
              type="number"
              style={isSearchOpen ? {width: '86.667vw', border: "1px solid #2253FF" } : {width:'148px'}}
              value={currentSearch}
              isSearchOpen={isSearchOpen}
              onFocus={onSearchFocus}
              onBlur={onSearchBlur}
              onChange={(e) => onSearch(e.target.value)}
            />
            {currentSearch &&
              <div className={styles.clearIconContainer} onClick={onClearClick}>
                <div className={styles.clearButton}><CloseIcon /></div>
              </div>
            }
          </div>
        </div>}
      
      {confirmNavigationModal}
    </div>
  )
}

TopNav.defaultTypes = {
  currentSearch: '',
}

TopNav.propTypes = {
  currentSearch: PropTypes.string,
  onClearSearch: PropTypes.func,
  onSearch: PropTypes.func,
}

export default memo(TopNav)
